import popup from "./popup";
import modal from "./modal";
import webConfig from "../game/config/config";
import {createAvatar} from '@dicebear/avatars';
import * as style from '@dicebear/avatars-bottts-sprites';
import {errors} from "../game/config/errors.js";
import UserMgr from "../UserMgr.js";
import {ERROR_LACK_OF_COINS} from "../game/config/constants.js";
import TranslateService from "../services/TranslateService.js";
import GlobalVars from "../GlobalVars.js";
const seedrandom = require('seedrandom');

export function networkProblemAndReloadPage() {
    popup.error('Network problem, reload in 5 sec');
    setTimeout(() => {
        window.location.reload()
    }, 5000);
}

export function decimalCount (number) {
    // Convert to String
    const numberAsString = number.toString();
    // String Contains Decimal
    if (numberAsString.includes('.')) {
        return numberAsString.split('.')[1].length;
    }
    // String Does Not Contain Decimal
    return 0;
}


export function amountFormat (value, digits) {
    if (!value) {
        value = '0';
    }

    if (parseFloat(value) == 0) {
        return '0';
    }

    if (!digits) {
        digits = 8;
    } else {
        digits = parseInt(digits);
    }

    value = value.toString().replace(/(^0+)([1-9]\d*)/, (...val) => {
        return val[2]
    });

    let index = value.indexOf('.');
    if (index == -1) {
        value += '.';
        index = value.length + 1;
    }
    return (value + '0'.repeat(digits)).substr(0, index + digits + 1);
};
export function numberTrim (value, digits) {
    if (value) {


        if (!isNaN(value))
            value = value.toString();

        if (digits) {
            value = amountFormat(value, digits);
        }

        if (value.match(/(\d+\.\d*)/g) != null) {
            value = value.replace(/0+$/, '');
            if (value.substr(-1) == '.') {
                value = value.substr(0, value.length - 1);
            }
        }
        //value = value.replace(/(^0+)([1-9]\d*)(\.)/, (...val) => { return val[2] + val[3] });
        value = value.replace(/(^0+)([1-9]\d*)/, (...val) => {
            return val[2]
        });
        value = value.replace(/(^0+)(0)(\.)/, (...val) => {
            return val[2] + val[3]
        });
    }

    return value;
};

export function normalizeNumber (value, digits) {
    if (value != '') {
        value = value.replace(',', '.');
        let matches = value.match(/[\d.]/g);

        if (matches != null) {
            value = matches.join('');

            if (value == '00') {
                return '0';
            }

            if (value.indexOf('.', value) == 0) {
                return '0.';
            }

            let idx = value.indexOf('.');
            if (value.indexOf('.', idx + 1) > -1) {
                value = value.substr(0, value.length - 1);
            }

            if (digits > 0) {
                value = value.substr(0, idx + digits + 1);
            }
        } else {
            value = 0;
        }
    }

    return value;
}

export function showTooltip (element, message) {

    //element.attr('data-bs-original-title', message);
    element.attr('title', message)
        .tooltip({
            trigger: 'manual',
            container: 'body',
        })
        .tooltip('show').delay(2000).queue((next) => {
        element.tooltip('hide');
        next();
    });
};

export function fallbackCopyTextToClipboard (text) {

    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');

    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}
export function copyTextToClipboard (text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        //export popup.show('success', message);
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
}

export function prettyTime (value) {

    const days = numberTrim(value / 60 / 60 / 24, 1);
    if (days > 1) {
        return `${days}  ${__("days")}`;
    }

    const hours = numberTrim(value / 60 / 60, 1);
    if (hours > 1) {
        return `${hours}  ${__("hours")}`;
    }

    const minutes = Math.floor(value / 60);
    if (minutes > 0) {
        return `${minutes}  ${__("minutes")}`;
    }

    return `${Math.floor(value)}  ${__("seconds")}`;
}

export const loader = {
    show: function () {
        $('#loader').show();
    },
    hide: function () {
        $('#loader').hide();
    },
}


export function swapCoords (arr) {

    if (arr.length == 2 && !isNaN(arr[0])) {
        return [arr[1], arr[0]];
    }

    const result = [];
    for (const i in arr) {
        result.push([arr[i][1], arr[i][0]]);
    }

    return result;
}

export async function saveError (errorMessage) {
    return saveDebug(errorMessage);
    // return postData(`${config.server_url}/user/saveError`, {
    //     message: errorMessage
    // });
}


export async function loadConfig() {

    const allowed = ['SERVER_URL', 'OFFICE_URL', 'DEBUG', 'WS_URL', 'MAP_KEY'];
    const filtered = Object.keys(process.envjs)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
            obj[key.toLowerCase()] = process.envjs[key];
            return obj;
        }, {});


    const serverResponse = await fetch(`${filtered.server_url}/config/all`);
    if (serverResponse.status == 200) {
        const serverConfig = await serverResponse.json();

        window.constants = serverConfig.constants;
        window.config = {...serverConfig.config, ...filtered};
        return true;
    } else {
        return false;
    }
}

export async function saveDebug (err) {


    if (UserMgr.currentUser?.id == 1 || UserMgr.currentUser?.id ==  2) {

        // const {message, source, lineno, colno, error} = err;
        return postData(`${config.server_url}/user/saveDebug`, {
            message: err
            // 'Error:'+ message+ ' at'+ source+ ' line:'+ lineno+ ' column:'+ colno+ ' ' +error
        });

    }

}

export async function postData (url = '', data = {}) {

    const token = await getToken();
    if (!token) {
        popup.error('Token expired. Please refresh page.');
        return false;
    }

    const bearer = 'Bearer ' + token;
    loader.show();
    try {
        // Default options are marked with *
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                'Authorization': bearer,
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *client
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        const result = await response.json(); // parses JSON response into native JavaScript objects
        if (result.status == 'error' || result.error) {


            if (result.error == 'Unauthorized') {
                await getToken(true);
                networkProblemAndReloadPage();
            } else {

                if (errors[result.code]) {
                    const errorInfo = errors[result.code];

                    if (result.code != ERROR_LACK_OF_COINS)
                        modal.add(errorInfo.title, false, errorInfo.template);

                } else if (result.code == 105) {
                    popup.error(__(result.message));
                    await locationMgr.syncUserCoords(true);
                } else if (result.message) {
                    popup.error(__(result.message));
                }
            }
        }

        loader.hide();
        return result;

    } catch (e) {
        loader.hide();
        console.log(e);
        popup.error('Connection problem');
        return false;
    }
}

export async function getData(url = '', data = {}) {
    // Создаем URL с параметрами
    const urlWithParams = new URL(url, window.location.origin);

    // Добавляем параметры из data
    Object.keys(data).forEach(key => urlWithParams.searchParams.append(key, data[key]));

    let response = await fetch(urlWithParams, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *client
    });

    response = await response.json();
    return response;
}


export async function getToken (forceReload = false) {

    let token = sessionStorage.getItem('token');
    if (!token || forceReload) {

        try {
            let response = await fetch(`${webConfig.office_url}/token`, {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json',
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *client
            });
            response = await response.json();



        if (response.status == 'ok') {
            token = response.token;
            sessionStorage.setItem('token', response.token);
        } else if (response.redirect) {
            window.location = response.redirect;
            return;
        }

        } catch(e) {
            popup.error('Network problem, reload in 4 sec');
            setTimeout(() => {
                window.location.reload()
            }, 4000);
        }
    }

    return token;
}


export function getRandomArbitrary (min, max, seed = false) {

    let rnd;
    if (!seed) {
        rnd = Math.random();
    } else {
        rnd = seedrandom(seed)();

    }

    return rnd * (max - min) + min;
}

export function updateModel(model, params) {
    for (const [key, value] of Object.entries(params)) {
        if (value == null)
            delete model[key];
        else
            model[key] = value;
    }
}


export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function cloneObject(objectToClone) {
    const stringified = JSON.stringify(objectToClone);
    const parsed = JSON.parse(stringified);
    return parsed;
}

export function toLocaleDateTime(isoDate) {


    const date = new Date(isoDate);

// Получаем текущую локаль из браузера
    const locale = navigator.language;

// Форматируем дату и время в соответствии с локалью
    const formattedDate = date.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    const formattedTime = date.toLocaleTimeString(locale, {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    });

// Объединяем отформатированные дату и время
    return `${formattedDate} ${formattedTime}`;
}

export function getResourceName(id) {
    return game.config.currencies[id].name;
}

export function showUserModal(e) {
    return UserMgr.showInfo(e);
}

export function getResourceImage(currency_id) {
    if (currency_id == constants.CURRENCY_MATERIA) {
       return UserMgr.getFractionIcon();
    }
    return game.config.currencies[currency_id]?.img;
}

export function getResourceTitle(id, amount) {
    return  game.config.currencies[id] ? game.config.currencies[id].nameMany.replace('_', ' ') : '';
}

export function trans(text) {
    return TranslateService.translate(text);
}

export function showCurrencyInfo(currencyId) {
    GlobalVars.currencyInfo.show(currencyId);
}

export function modalPopup(data) {
    GlobalVars.modalPopup.showModal(data);
}


export function isTouchEvent(event) {
    return  event.originalEvent && 'touches' in event.originalEvent;;
}

